<template>
  <div class="wrapper">
    <vx-card
      v-for="crew in crewList"
      :key="crew.id"
      class="vx-card card-base"
      :class="priorityClass(crew)"
    >
      <div class="content-container">
        <div class="name-alert-container">
          <span class="name">{{ crew.name }}</span>

          <div
            class="info-icon-container"
            v-if="hasWarning(crew) || hasCaution(crew)"
          >
            <vx-tooltip-with-slot-text position="bottom">
              <template v-slot:text>
                <tooltip-crew-assignment-alert :alerts="crew.crewErrors" />
              </template>
              <template v-slot:inner>
                <span
                  class="material-icons alert-icon cursor-pointer"
                  :class="priorityIconClass(crew)"
                >
                  error
                </span>
              </template>
            </vx-tooltip-with-slot-text>
          </div>
        </div>
        <div class="info-util-container">
          <span class="info">{{ info(crew) }}</span>
          <span class="until">{{ until(crew) }}</span>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import { TooltipCrewAssignmentAlert } from "../../components/tooltips";
import moment from "moment";

export default {
  name: "CellRendererCrewCard",
  components: {
    VxTooltipWithSlotText,
    TooltipCrewAssignmentAlert,
  },
  computed: {
    crewList() {
      return this.params.value;
    },
  },
  methods: {
    info(crew) {
      let days = "-";

      if (crew.startAt) {
        const startAt = moment(new Date(crew.startAt));
        days = moment(this.nowDate).diff(startAt, "days", false);
      }

      return `${days}日乗船中`;
    },
    until(crew) {
      if (!crew.endAt) return "";
      const date = new Date(crew.endAt);
      const options = { month: "numeric", day: "numeric" };
      const formatted = date.toLocaleDateString("ja-JP", options);
      return `〜${formatted}`;
    },
    hasAlert(crew) {
      return crew.crewErrors && crew.crewErrors.length > 0;
    },
    hasCaution(crew) {
      return crew.crewErrors.some(alert => alert.alert_type === "CAUTION");
    },
    hasWarning(crew) {
      return crew.crewErrors.some(alert => alert.alert_type === "WARNING");
    },
    priorityClass(crew) {
      if (this.hasWarning(crew)) return "card-warning";
      if (this.hasCaution(crew)) return "card-caution";
      return "card-normal";
    },
    priorityIconClass(crew) {
      if (this.hasWarning(crew)) return "warning";
      if (this.hasCaution(crew)) return "caution";
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.vx-card {
  ::v-deep {
    box-shadow: 1px 1px 2px 1px #00000029 !important;
    .vx-card__body {
      padding: 0 !important;
    }
  }
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 12px 8px;

  .card-base {
    min-width: 140px;

    .content-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2px;
      padding: 4px 8px;

      .name-alert-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 2px 0px;

        position: relative;

        .name {
          font-family: $aisea-font-family;
          font-weight: 600;
          color: $aisea-dark-gray;
          font-size: 12px;

          line-height: 16px;
        }

        .info-icon-container {
          width: 14px;
          height: 14px;

          position: absolute;
          top: 0;
          right: 0;

          .alert-icon {
            font-size: 16px;
            &.warning {
              color: #e02e22;
            }
            &.caution {
              color: #ffd400;
            }
          }
        }
      }

      .info-util-container {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: $aisea-font-family;
        font-size: 10px;
        color: $aisea-dark-gray;

        .info {
          text-align: left;
        }

        .until {
          text-align: right;
        }
      }
    }
  }
}

.card-normal {
  background-color: $aisea-white;
}
.card-warning {
  background-color: #ffccc9;
}
.card-caution {
  background-color: #fff8e3;
}
</style>
